import React from "react";
import { Mutation } from "react-apollo";
import { UPDATE_LOCATION } from "../../../graphql";
import InputText from "../../UI/Input/Text";
import Text from "../../Type/Text";
import Button from "../../UI/Button";
import { Rowz, Spacer } from "../../Layout/Layout";

class LocationUpdateForm extends React.Component {
  constructor(props) {
    super(props);
    const {
      name,
      address,
      postalCode,
      place,
      refNumber
    } = props.locationData;


    this.state = {        
        name,
        organizationID: props.organizationID,
        address,
        postalCode,
        place,
        refNumber
    };

  }

  handleInputChange = (name, value) => {
    
      this.setState({
        [name]: value
      });
    
  };

  render() {    
    return (
      <Mutation mutation={UPDATE_LOCATION}>
        {(updateLocation, { data, called, error, loading }) => {
          if (called && !error && !loading) {
            window.location.reload();
          }
          return (
            <form
              onSubmit={e => {
                e.preventDefault();
                updateLocation({ variables: { id: this.props.locationID, input: this.state } });
              }}
            >
              <Spacer>
              <Spacer>
                    <Rowz>
                      <Text>Name:</Text>
                      <InputText
                        name="name"
                        value={this.state.name || undefined}
                        placeholder="Hoofddorp Toolenburg"
                        required
                        onChange={value =>
                          this.handleInputChange("name", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Address:</Text>
                      <InputText
                        name="name"
                        value={this.state.address || undefined}
                        placeholder="Toolengstraat 123A"
                        required
                        onChange={value =>
                          this.handleInputChange("address", value)
                        }
                      />
                    </Rowz>
                  </Spacer>

                  <Spacer>
                    <Rowz>
                      <Text>Postal Code:</Text>
                      <InputText
                        name="postalCode"
                        value={this.state.postalCode || undefined}
                        placeholder="2011GM"
                        required
                        onChange={value =>
                          this.handleInputChange("postalCode", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Place:</Text>
                      <InputText
                        name="place"
                        value={this.state.place || undefined}
                        placeholder="Zuid"
                        required
                        onChange={value =>
                          this.handleInputChange("place", value)
                        }
                      />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Reference number:</Text>
                      <InputText
                        name="refNumber"
                        value={this.state.refNumber || undefined}
                        placeholder="12345"
                        required
                        onChange={value =>
                          this.handleInputChange("refNumber", value)
                        }
                      />
                    </Rowz>
                  </Spacer>                  

                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Update
                    </Button>
                  </Spacer>
              </Spacer>
            </form>
          );
        }}
      </Mutation>
    );
  }
}

export default LocationUpdateForm;
